import React from 'react';
import SayHelloSection from '../components/Contact/SayHelloSection';
import ContactEnquirySection from '../components/Contact/ContactEnquirySection';
import BranchLocator from '../components/Contact/BranchLocator';
import FranchiseMapSection from '../components/Contact/FranchiseMapSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_0567.JPG";

const Contact = () => {

const centersData = [
  {
    title: "CO-CO Authorised Training Centers",
    state: "",
    centers: [
      { 
        name: "NIECCE Chandra Layout, Bengaluru",
        call: "9886855700 / 8095811112",
        email: "info@niecce.com",
        address: "No.1566, 9th Cross, Little Kidz Road, Chandralayout, Bengaluru",
        pin: "560040",
        map: "https://goo.gl/maps/mPvEvEpXjuu",
        link: "#"
      },
      { 
        name: "NIECCE Jayanagar, Bengaluru",
        call: "9901061160",
        email: "info@niecce.com",
        address: "NIECCE Jayanagar, RKS High school campus, 27th main, Jayanagar 7th block, Bangalore.",
        pin: "560041",
        map: "https://goo.gl/maps/tkRAEg1a27K2",
        link: "#"
      },
      { 
        name: "NIECCE Rajajinagar, Bengaluru",
        call: "9108544922",
        email: "info@niecce.com",
        address: "NIECCE Rajajinagar, Sri Sai woman's College campus, Near Navarang Rajajinagar Circle, Bengaluru.",
        pin: "560010",
        map: "https://goo.gl/maps/VYHxgxHxbyx",
        link: "#"
      },
      { 
        name: "NIECCE Indiranagar, Bengaluru",
        call: "7022334402",
        email: "info@niecce.com",
        address: "NIECCE Indiranagar Holy Shepherd School, 9th Cross, 1st Stage, Indiranagar, Bangalore-38.",
        pin: "560038",
        map: "https://goo.gl/maps/JLKnZRhV4dQ2",
        link: "#"
      },
      { 
        name: "NIECCE Electronic City, Bengaluru",
        call: "+91 84318 88784",
        email: "info@niecce.com",
        address: "Near Wipro Gate, Electronic City Phase",
        pin: "560100",
        map: "https://goo.gl/maps/tvHEkgHcrnd4CPAJ9",
        link: "#"
      },
      { 
        name: "NIECCE Yelahanka, Bengaluru",
        call: "9611661190",
        email: "info@niecce.com",
        address: "NIECCE Yelahanka,Near NES Bus Stop,7th Cross, Yelahanka New Town.",
        pin: "560064",
        map: "https://goo.gl/maps/tvHEkgHcrnd4CPAJ9",
        link: "#"
      }
    ]
  },

  {
    title: "Authorised Training Centers",
    state: "Bengaluru",
    centers: [
      { name: "NIECCE Ullal, Bengaluru", call: "9886855700 / 8095811112", email: "info@niecce.com", address: "NIECCE Ullal, #45, 3rd cross, Ullal Main Rd, near SLVB Bakery, Jnana Jyothi Nagar, Bengaluru, Karnataka", pin: "560056", map: "https://goo.gl/maps/JVBUFBkdovBRetXk6", link: "#" },
      { name: "NIECCE Whitefield, Bengaluru", call: "8660170956", email: "info@niecce.com", address: "NIECCE Whitefield No 6, Rudrappa layout, next to Nishanth Prime, Immadihalli, Whitefield, Bengaluru, Karnataka", pin: "560066", map: "https://goo.gl/maps/tvHEkgHcrnd4CPAJ9", link: "#" },
      { name: "NIECCE MS Palya, Bengaluru", call: "7483596234/ 9741233113", email: "info@niecce.com", address: "NIECCE M S Palya,#13, 1st cross, Someshwara Layout, Opp. Sambram College, Vidhyaranyapura Post, Bengaluru.", pin: "560097", map: "https://goo.gl/maps/e3LtYb29kg9FMKdi6", link: "#" },
      { name: "NIECCE Rajarajeshwari Nagar, Bengaluru", call: "98800 75345", email: "info@niecce.com", address: "NIECCE Rajarejeshwari Nagar, The Child's kingdom, 315, 10th cross ideal homes town ship Rajarajeshwari Nagar, Bengaluru", pin: "560098", map: "https://goo.gl/maps/amvw9hqvtuZpYufs8", link: "#" },
      { name: "NIECCE Kithanahalli, Bengaluru", call: "9740449264/ 9902008830", email: "info@niecce.com", address: "NIECCE Kittanahalli, Sy. No. 119/25, Kithanahalli Post, Dasanapura Hobli, Bengaluru North, Karnataka", pin: "560130", map: "https://goo.gl/maps/KNWP4tadb3cVdggs6", link: "#" },
      { name: "NIECCE Marathahalli, Bengaluru", call: "9611168923/ 9611904455", email: "info@niecce.com", address: "NIECCE Marathalli #23, Vritti Preschool, Green Garden layout, Sai Baba Temple Rd., Munnekolala, Bengaluru, Karnataka", pin: "560037", map: "https://goo.gl/maps/GuDtP4FhayZKBw8o9", link: "#" },
      { name: "NIECCE Matthikere, Bengaluru", call: "7019806668", head: "Chandrakala", email: "mtkbrightkid@gmail.com", address: "Bright Kid Montessori House,#305,5th Cross,1st stage,1st phase, Gokula,Mathikere, Bangalore", pin: "560054", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Harluru, Bengaluru", call: "7795822061 / 9108753091", head: "Pooja Chatterjee", email: "mtkbrightkid@gmail.com", address: "Site.no.88,89 & 90, 2nd Cross, Reliable Resiidency Phase 3, Sector 2 HSR Extension, Harluru, Bengalore", pin: "560102", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Sanjaynagar, Bengaluru", call: "8197208028", head: "Saritha", email: "sachibob26@gmail.com", address: "Rubics Cube Montessori, 27, 2nd Main Rd, NGEF Layout, Postal Colony, Sanjayanagara, Bengaluru, Karnataka ", pin: "560094", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Laggere, Bengaluru", call: "9945551324", head: "Rashmi G N", email: "littlekidzpreschool.laggere@gmail.com", address: "Little Kidz, 26/1, Muneshwara Badavane,Laggere,Bangalore", pin: "560058", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Navodayanaagr, Bengaluru", call: "9591977740", head: "Rekha  N", email: "lu.n.rekha@gmail.com", address: "Cradle to Stars, #40/41, 4th Cross, 7th main, Navodhaya nagar, J.P.Nagar 7th phase, Bengaluru", pin: "560076", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Dodda-Bommasandra, Bengaluru", call: "9731197460", head: "Rekha", email: "rekha2279@yahoo.com", address: "65, Munikalappa Layout, Chamundeshwari Layout, Doddabommasandra, Bengaluru, Karnataka", pin: "560013", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE TC Palya, Bengaluru", call: "9900371746", head: "Sumitha / Kavitha", email: "littlekidzfuture@gmail.com", address: "Little Kidz, 8, 5th Main Rd, Raghavendra Nagar, Ramamurthy Nagar, Bengaluru, Karnataka ", pin: "560016", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE  Basavanapura Gate, (Bannerghatta Road)", call: "9972562266 / 9972562255", head: "Qamar Afroz", email: "littlehorizons.adm@gmail.com", address: "Little Horizons Montessori, 671-1, bannerghatta Road, Opp. Prestige Part Square, Basavanapura, Bengaluru", pin: "560083", map: "https://maps.app.goo.gl/w2v1Ndv9wbkJDXUE7", link: "#" },
      { name: "NIECCE Nagadevanahalli, Bengaluru", call: "9972562266 / 9972562255", head: "REKHA", email: "vsskidskingdom@gmail.com", address: "287/1, 2nd Main Road, Jagajyothi Layout, Nagadevanahalli, Bengaluru", pin: "560056", map: "https://maps.app.goo.gl/BJym4M5ZW8nJJaPJ9", link: "#" }
    ]
  },

  {
    title: "Authorised Training Centers",
    state: "Karnataka",
    centers: [
      { name: "NIECCE Doddaballapura, Karnataka", call: "9845606364/ 9886855700", email: "info@niecce.com", address: "NIECCE Doddaballapur, Palanjoghalli, PLUTO CAMPUS 2nd Main Road, 33rd Cross Rd, J. P. Nagar, Doddaballapura, Karnataka", pin: "561203", map: "https://goo.gl/maps/JVBUFBkdovBRetXk6", link: "#" },
      { name: "NIECCE Channapatna, Karnataka", call: "9886855700 / 8095811112", email: "info@niecce.com", address: "NIECCE Channapatna, Channambika College Road, Channapatna, Karnataka.", pin: "562160", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" },
      { name: "NIECCE Mysore, Karnataka", call: "9740408333/ 9945777672/ 9945757507", email: "info@niecce.com", address: "NIECCE Mysore, No. 31, 80 Feet Road, BEML Layout 2nd Stage, Rajarajeshwari Nagar, Dattagalli 3rd Stage, Mysore.", pin: "570001", map: "https://goo.gl/maps/k3k8f3zXR42MU6Tv6", link: "#" },
      { name: "NIECCE Tumkuru, Karnataka", call: "7022197881", email: "info@niecce.com", address: "NIECCE Tumkur No 44, 1st Floor, 2nd Cross, Ashok Nagar, Tumakuru, Karnataka", pin: "572103", map: "https://g.page/NIECCE?share", link: "#" },
      { name: "NIECCE Kalburgi, Karnataka", call: "9900975676/ 9844014303", email: "info@niecce.com", address: "NIECCE KALBURGI 582/A, Near Koranti Hanuman Temple, Near al-badar dental college, Kalburgi, Karnataka ", pin: "585102", map: "https://goo.gl/maps/Q9kaQAn6n7BYQ8RT7", link: "#" },
      { name: "NIECCE Hubballi, Karnataka", call: "9945160180", email: "info@niecce.com", address: "NIECCE Hubballi, Mr. Manjunath c Sheshagiri, 27/1196, Saraswati, Shanti Colony North, Vishweshwar Last Bus Stop, Hubballi ", pin: "580032", map: "https://maps.app.goo.gl/3DyqwoqQ4YNnE6Tx9", link: "#" }
    ]
  },

  {
    title: "Authorised Training Centers",
    state: "Andhra Pradesh",
    centers: [
      { name: "NIECCE Guntakal", head: "Nagarjun Karnatakam", call: "6300026699", email: "thecosmicfoundation@gmail.com", address: "Penguin Montessori, NIOER, The Cosmic Foundation, 10/188, Mandy Bazaar, Guntakal, Andhra Pradesh", pin: "515801", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" }
    ]
  },

  {
    title: "Authorised Training Centers",
    state: "Tamil Nadu",
    centers: [
      { name: "NIECCE Krishnagiri", head: "Alphanso Mary", call: "9003656604", email: "alphonsastalin@gmail.com", address: "D.no. 3/376-c Kandhikuppam Village and post Bargur TK Krishnagiri Dt", pin: "635108", map: "https://goo.gl/maps/KsuHrNLSk8XUsmzm9", link: "#" }
    ]
  }
];




  return (
    <>
<UniqueBanner
  image={BannerImg}
  title="Teacher Training Course in Bangalore"
  subtitle="Reach out to us for inquiries, support, or collaboration"
/>
<SayHelloSection />
<ContactEnquirySection />
<BranchLocator data={centersData} />
<FranchiseMapSection />
    </>
  );
};

export default Contact;
